import { useTranslation } from "react-i18next";
import { TextField } from "@/shared/ui/core";
import { EditorialBlock, type EditorialBlockLocaleProps } from "./EditorialBlock";
import { useBlockFilled } from "./useBlockFilled";

/**
 * Bloque 3 · Los cuatro datos de un vistazo, bajo el botón de compra.
 *
 * Son cuatro y siempre los mismos —contenido, dosis, duración,
 * certificación— porque la ficha los pinta en una rejilla fija de cuatro
 * huecos. No es una lista que crezca: si fueran cinco, el quinto no
 * tendría dónde ir.
 */
export function EditorialMetadataBlock({ locale }: EditorialBlockLocaleProps) {
  const { t } = useTranslation();
  const name = `editorial.${locale}.metadata`;
  const filled = useBlockFilled(name);

  return (
    <EditorialBlock
      name={name}
      title={t("Datos de un vistazo")}
      description={t("Los cuatro datos que van bajo la compra. Corto: caben 60 letras.")}
      filled={filled}
    >
      <TextField
        name={`${name}.content`}
        label={t("Contenido")}
        placeholder={t("60 cápsulas")}
      />
      <TextField name={`${name}.dose`} label={t("Dosis")} placeholder={t("2 al día")} />
      <TextField
        name={`${name}.duration`}
        label={t("Duración")}
        placeholder={t("30 días")}
      />
      <TextField
        name={`${name}.cert`}
        label={t("Certificación")}
        placeholder={t("Cofepris")}
      />
    </EditorialBlock>
  );
}
